import { render, staticRenderFns } from "./EvaluationNodeComments.vue?vue&type=template&id=024b6bbc&scoped=true&"
import script from "./EvaluationNodeComments.vue?vue&type=script&lang=js&"
export * from "./EvaluationNodeComments.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationNodeComments.vue?vue&type=style&index=0&id=024b6bbc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b6bbc",
  null
  
)

export default component.exports